import {Controller} from "@hotwired/stimulus"
import lightGallery from "lightgallery";

// Plugins
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

export default class extends Controller {
    static values = {
        gallery: Array,
        thumbnail: {
            type: Boolean,
            default: true,
        }
    }

    connect() {
        if (!this.galleryValue.length) return

        const lgContainer = this.element
        const inlineGallery = lightGallery(lgContainer, {
            plugins: [lgThumbnail, lgZoom],
            thumbnail: this.thumbnailValue,
            thumbHeight: "60px",
            thumbWidth: 80,
            container: lgContainer,
            dynamic: true,
            download: false,
            // mode: "lg-fade",
            speed: 200,
            // Turn off hash plugin in case if you are using it
            // as we don't want to change the url on slide change
            hash: false,
            // Do not allow users to close the gallery
            closable: false,
            // Add maximize icon to enlarge the gallery
            showMaximizeIcon: true,
            // Append caption inside the slide item
            // to apply some animation for the captions (Optional)
            appendSubHtmlTo: '.lg-item',
            // Delay slide transition to complete captions animations
            // before navigating to different slides (Optional)
            // You can find caption animation demo on the captions demo page
            dynamicEl: this.galleryValue
        })

        inlineGallery.openGallery()
    }
}
